// extracted by mini-css-extract-plugin
export var badge = "_ic-2";
export var detailsPanel = "_ic-0";
export var resultRow = "_ic-1";